export default "__VITE_ASSET__8W7oBuIb__"